module.exports = __webpack_public_path__ + "img/replay.c344dc26.png";